module.exports = __webpack_public_path__ + "img/valance-standard.a6c2d615.jpg";